import axios from "axios";
const Development = true;
const AxiosInstance = axios.create({
  baseURL: Development ? "https://devapi.transformationalrunners.com" : "https://api.transformationalrunners.com",
});
AxiosInstance.interceptors.request.use(
  function (config) {
    const transformatonalRunner = JSON.parse(localStorage.getItem("TRANSFORMATIONAL_RUNNER"));
    config.headers.token = transformatonalRunner?.token;
    config.headers.apikey = transformatonalRunner?.apikey;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem("TRANSFORMATIONAL_RUNNER");
        window.location.pathname = "/";
      } else {
        console.error("Response Error:", error.response);
      }
    } else if (error.request) {
      console.error("Request Error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
